<template>
    <div class="w-full">
        <div
            class="bg-jackpot-bg bg-opacity-80 bg-no-repeat bg-cover bg-blend-multiply text-white drop-shadow flex items-center w-full whitespace-nowrap overflow-hidden">
            <p class="pl-[100%] py-1 text-sm leading-1 marquee inline-flex items-center gap-1">
                <span class="uppercase">Jackpot <span class="font-semibold">{{ lamportsToSol(jackpot.current)
                }}</span></span>
                <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                <span v-if="jackpot.turns > 0" class="text-xs">(win a Sit & Go or Duels in {{ jackpot.turns }} or less
                    turns)</span>
            </p>
        </div>
    </div>
</template>

<script>
import solana from '../mixins/solana'
export default {
    name: 'Jackpot',
    props: ['jackpot'],
    mixins: [solana]
}
</script>
